import React, { useReducer, useEffect } from "react";
import "./App.css";
import { reducer, initialState } from "./lib/reducer";
import { actions } from "./lib/actions";
import { StateContext } from "./lib/StateContext";
import Home from "./pages/Home";
import Game from "./pages/Game";
import useInterval from "./lib/useInterval";

let initState;

try {
  initState = JSON.parse(localStorage.getItem("gameState"));
  const isCorrectVersion =
    initState.version && initState.version === initialState.version;

  console.log(initState.version, initialState.version);

  if (!isCorrectVersion) {
    initState = null;
    localStorage.removeItem("gameState");
  }
} catch (error) {
  console.log(
    "either no data or corrupted game data found, starting new",
    error
  );
}

function App() {
  const [state, dispatch] = useReducer(reducer, initState || initialState);
  useInterval(() => {
    dispatch(actions.doTick());
  }, 5000);

  useEffect(() => {
    console.log(state);
    localStorage.setItem("gameState", JSON.stringify(state));
  }, [state]);
  return (
    <StateContext.Provider value={[state, dispatch]}>
      <div className="App">
        {state.currentPage === "HOME" ? (
          <Home nextPage="GAME" />
        ) : state.currentPage === "GAME" ? (
          <Game />
        ) : null}
      </div>
    </StateContext.Provider>
  );
}

export default App;
